import { motion } from "framer-motion";
import { skills } from "../data/portfolio";

export default function Skills() {
  return (
    <section id="skills" className="section">
      <div className="section-header">
        <span className="section-label">Expertise</span>
        <h2>Technical &amp; Professional Skills</h2>
        <p className="section-desc">
          Core competencies spanning nanofabrication, optical design, simulation, and research leadership.
        </p>
      </div>

      <div className="skills-grid">
        {skills.map((skill, i) => (
          <motion.span
            key={skill}
            className="skill-chip"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.04, duration: 0.3 }}
          >
            {skill}
          </motion.span>
        ))}
      </div>
    </section>
  );
}
